import { getAuthApiBaseUrl, resolveAuthResourceUrl } from "@/core/api/apiHosts";

const BASE_URL = getAuthApiBaseUrl();

export class ApiConfig {
  static readonly BASEURL = BASE_URL;
  static readonly AUTH_BASE_URL = BASE_URL;

  // Authentication — global auth service
  static readonly LOGIN = `${BASE_URL}/auth/login`;
  static readonly REFRESH_TOKEN = `${BASE_URL}/auth/refresh`;
  static readonly SIGNUP = `${BASE_URL}/onboarding/register`;
  static readonly REGISTRATION_EXISTS = `${BASE_URL}/onboarding/exist`;
  static readonly SETUP_PASSWORD = `${BASE_URL}/auth/set-password`;
  static readonly RESET_PASSWORD = `${BASE_URL}/auth/reset-password`;
  static readonly CHANGE_PASSWORD = `${BASE_URL}/auth/change-password`;
  static readonly QR_CODE = `${BASE_URL}/auth/totp/setup`;
  static readonly RESET_TOTP = `${BASE_URL}/auth/reset-totp`;
  static readonly ENABLE_TOTP = `${BASE_URL}/auth/totp/verify-setup`;
  static readonly VERIFY_TOTP = `${BASE_URL}/auth/verify-totp`;
  static readonly SEND_EMAIL_OTP = `${BASE_URL}/auth/send-email-otp`;
  static readonly VERIFY_EMAIL_OTP = `${BASE_URL}/auth/verify-otp`;

  static readonly USER_SETTINGS = `${BASE_URL}/users/settings`;
  static readonly USERS_ME = `${BASE_URL}/users/me`;

  // Locations
  static readonly COUNTRIES = `${BASE_URL}/locations/countries`;
  static readonly STATES = `${BASE_URL}/locations/states`;
  static readonly CITIES = `${BASE_URL}/locations/cities`;

  // Designations
  static readonly DESIGNATIONS = `${BASE_URL}/designations`;

  // Agreements
  static readonly AGREEMENT_IDS = `${BASE_URL}/agreements/registration/required`;
  static readonly REGISTRATION_REQUIRED_CLAUSES = `${BASE_URL}/agreements/registration/clauses/required`;

  static agreementDetails(agreementId: string): string {
    return `${BASE_URL}/agreements/${agreementId}`;
  }

  //download agreement
  static registrationAgreementPdf(requestId: string): string {
    return `${BASE_URL}/onboarding/requests/${requestId}/agreement-pdf`;
  }

  /** Public post-register PDF. Prefer `download_path` from the register response. */
  static registrationAgreementPdfUrl(
    downloadPath: string | null | undefined,
    requestId: string,
  ): string {
    if (downloadPath) {
      return resolveAuthResourceUrl(downloadPath);
    }
    return ApiConfig.registrationAgreementPdf(requestId);
  }
}
